import React, { useEffect } from "react";
import { useRegion } from "./Hooks";

function Region({ set = () => {}, data = {}, value }) {
  const { loading, citys, provinec, getProvince, getRegion, getCity } =
    useRegion({ set });
  useEffect(() => {
    getProvince();
  }, []);
  return (
    <>
      {data && data.region && data.region[0] && (
        <div className="row">
          <div className="col">
            <h6>
              مقادیر قبلی :{" "}
              {`${data.province[0].name} - ${data.city[0].name} - ${data.region[0].name}`}
            </h6>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-12 ">
          <label htmlFor="">استان</label>
          {console.log("dw", value("province_id"))}
          <select
            onChange={({ target: { value } }) => getCity(value)}
            className="form-control"
            value={value("province_id")}
          >
            <option value="">انتخاب کنید</option>
            {provinec.map((element, key) => (
              <option key={key} value={element.value}>
                {element.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-12 ">
          <label htmlFor="">شهرستان</label>
          <select
            value={value("city_id")}
            className="form-control"
            onChange={({ target: { value } }) => set("city_id", value)}
          >
            <option value="">انتخاب کنید</option>

            {citys.map((element, key) => (
              <option key={key} value={element.value}>
                {element.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
}

export default Region;
